export class City {
  name: string;
  state: string;
  country: string;

  constructor() {
    this.name = null;
    this.state = null;
    this.country = null;
  }
}
